import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import OptionPanel from '../../OptionPanel';

const oiIcon = `${process.env.PUBLIC_URL}/workflows/oi.svg`;
const hiIcon = `${process.env.PUBLIC_URL}/workflows/hi.svg`;
const byeIcon = `${process.env.PUBLIC_URL}/workflows/bye.svg`;

class TriggerWorkflow extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  };

  isSelected(value) {
    return this.props.value === value;
  }

  onSelect(value) {
    return () => {
      this.props.onChange(value);
    };
  }

  render() {
    return (
      <div className="Steps-TriggerWorkflow">
        <label>Choose Trigger</label>
        <OptionPanel
          onSelect={this.onSelect('widget:loaded')}
          index={0}
          selected={this.isSelected('widget:loaded')}
          image={oiIcon}
        >
          Before the conversation is started
        </OptionPanel>
        <OptionPanel
          onSelect={this.onSelect('message:new-conversation')}
          index={1}
          selected={this.isSelected('message:new-conversation')}
          image={hiIcon}
        >
          When the conversation is started
        </OptionPanel>
        <OptionPanel
          onSelect={this.onSelect('conversation:closed')}
          index={2}
          selected={this.isSelected('conversation:closed')}
          image={byeIcon}
        >
          After the conversation is closed
        </OptionPanel>
      </div>
    );
  }
}

export default TriggerWorkflow;
